import { Component, OnInit } from '@angular/core';
import {UserService} from '../../_services/user.service'
import {VaService} from '../../_services/va.service'
import { ActivatedRoute, Params,Router } from '@angular/router';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  constructor(public userService:UserService,private vaService:VaService, private _activatedRoute: ActivatedRoute,private _router: Router) { }
  

  ngOnInit(): void {
    this._activatedRoute.data
      .subscribe((data: { config: any}) => {
        if(this.vaService.agents.length < 1) {
          this._router.navigate(['/'])
        }
        // if(this.vaService.agents.length < 1){
        //   console.log("redirecting to getting started")
        //   this._router.navigate(['dashboard/get-started'])
        // }
        // else if(data.config["active_va"]) {
        //   console.log("redirecting to active agent")
        //   this._router.navigate(['dashboard/agent',data.config["active_va"]])
        // }
        // else{
        //   console.log("redirecting to list")
        //   this._router.navigate(['dashboard/list-agents/'])
        // }        
      });
  }



}
